<template>
  <div class="" style="padding-bottom: 30px;">

    <div class="vld-parent" ref="formContainer">
      <!-- <h4>Yard Size: Up to {{ size }} sqft</h4>
      <h4>Mowing Frequency: {{ frequency }}</h4>
      <h4>Plan: ${{ price }} per month</h4> -->

      <form id="payment-form">
        <div id="card-element">
          <!-- Elements will create input elements here -->
        </div>

        <!-- We'll put the error messages in this element -->
        <div class="mt-2" id="card-errors" role="alert" style="font-size: 1rem; font-weight: 700; color: red;"></div>

      </form>
      <hr>
      <div class="" style="padding-bottom: 20px;">
        <!-- <button v-if="cardError || !card._complete" class="mylisting-button disabled-button" style="float: right; cursor: not-allowed; color: gray;" @click.prevent="">Complete</button>
        <button v-if="!cardError && card._complete" class="mylisting-button dark-button" style="float: right;" @click.prevent="createCustomer()">Complete</button> -->
        <button v-if="cardError || !cardComplete" class="mylisting-button disabled-button" style="float: right; cursor: not-allowed; color: gray;" @click.prevent="">Complete</button>
        <button v-if="!cardError && cardComplete" class="mylisting-button dark-button" style="float: right;" @click.prevent="createCustomer()">Complete</button>
      </div>
    </div>

    <!-- <div v-if="justSubscribed">
      <h3 class="">Thank you, welcome to the LocalStudent community!</h3>
      <h4>A member of our team will be in touch with you shortly to confirm all the details.</h4>
    </div> -->

  </div>
</template>

<script>

import axios from 'axios'

export default {
  props: ['email', 'user'],
  data() {
    return{
      stripe: null,
      elements: null,
      card: null,

      cardError: false,
      paymentIntentKey: null,

      // subscription: '',
      justSubscribed: false,
    }
  },
  computed: {
    cardComplete() {
      if (this.card) {
        return this.card._complete
      }
      else {
        return null
      }
    }
  },
  created() {
    // Scroll the window to top on load
    window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.setUpStripe()
  },
  mounted() {
    this.setUpStripe()
  },
  methods: {
    setUpStripe() {
      this.stripe = Stripe('pk_live_uQWLhWijqTDmzPz1heFX42gd00M0Oov1EL', {
      //   // stripeAccount: "acct_1GDXlTE7jOFBALyf" // Test account
      //   // stripeAccount: this.$store.getters.stripeAccountID
        // stripeAccount: 'acct_1GDZdaDZMNxDtGP7' // Express
        stripeAccount: 'acct_1Bg1iOJgWhWzU0rX', // Standard
      });
      this.elements = this.stripe.elements();
      // this.elements = stripe.elements();

      let style = {
        base: {
          // border: '1px solid #D8D8D8',
          // borderRadius: '4px',
          // color: "#000",

          // color: "#32325d",

          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },

        invalid: {
          // All of the error styles go inside of here.

          color: '#fa755a',
          iconColor: '#fa755a'
        }

      };

      // var card = elements.create('card');
      this.card = this.elements.create('card', { style: style });
      // this.card = elements.create('card', { style: style });
      // card.mount(this.$refs.card);
      this.card.mount("#card-element");
      // this.card.mount("#card-element");

      this.card.addEventListener('change', ({error}) => {
        const displayError = document.getElementById('card-errors');
        if (error) {
          displayError.textContent = error.message;
          this.cardError = true
        } else {
          displayError.textContent = '';
          this.cardError = false
        }
      });
    },
    createCustomer() {
      console.log(this.user)

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        // container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        container: this.fullPage,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
        this.$emit('subscribed')
      },8000)

      // let userEmail = this.user.email
      let userEmail = this.email
      let stripeAccount = this.$store.getters.stripeAccountID
      // let userID = this.user.id
      let userID = this.$store.getters.userID
      // let stripeCustomerID = this.user.stripe_customer_id // Don't have the stripe customer ID off the bat, we are creating the customer below!
      let subscription = this.subscription

      let fee_percentage = 0.0
      // if (this.subscription == this.monthlyPlanID) {
      //   fee_percentage = 6.66 // 1/15
      // }
      // else if (this.subscription == this.threeMonthPlanID) {
      //   fee_percentage = 10 // 3/30
      // }
      // else if (this.subscription == this.sixMonthPlanID) {
      //   fee_percentage = 13.33 // 6/45
      // }

      let vm = this

      this.stripe.createPaymentMethod({
        type: 'card',
        // card: cardElement,
        card: this.card,
        billing_details: {
          // email: 'jenny.rosen@example.com',
          // email: this.user.email,
          email: this.email,
        },
      })
        // .then(stripePaymentMethodHandler);
        // .then(res => {
        //   console.log(res)
        // })
        // .then(console.log('Payment method created'))
        .then(function(result) {
          if (result.error) {
            // showCardError(result.error);
            console.log(result.error);
          } else {
            // createCustomer(result.paymentMethod.id, cardholderEmail);

            console.log(result)

            console.log(userEmail)
            console.log(stripeAccount)
            console.log(userID)
            console.log(result.paymentMethod.id)

            // axios.post('/stripe-create-customer-test/', {
            axios.post('/stripe-create-customer/', {
              // email: authData.email,
              // email: this.user.email,
              email: userEmail,
              // stripe_account: state.stripeAccountID,
              // stripe_account: this.$store.getters.stripeAccountID,
              stripe_account: stripeAccount,
              // enginehire_id: res.data.pk,
              // enginehire_id: this.user.id,
              enginehire_id: userID,
              payment_method_id: result.paymentMethod.id,
              // payment_method_id: 'sdkf',
            })
              .then(res => {
                console.log('Stripe Customer Created')
                console.log(res.data)

                // // axios.post('/stripe-create-subscription-test/', {
                // axios.post('/stripe-create-subscription/', {
                //   stripe_account: stripeAccount,
                //   // customer_id: stripeCustomerID,
                //   customer_id: res.data.stripe_customer.id,
                //   plan_id: subscription,
                //   fee_percentage: fee_percentage,
                //   tax_percentage: 13,
                //   start_time: 1588334400, // https://www.epochconverter.com/, https://stripe.com/docs/billing/subscriptions/trials
                // })
                //   .then(res => {
                //     console.log('Stripe Subscription Created')
                //     console.log(res.data)

                //     // axios.patch('/api/people/'+userID.toString()+'/', {
                //     //   status: 'Subscribed',
                //     // })
                //     //   .then(res => {
                //     //     console.log(res)
                //     //     // this.justSubscribed = true // Want to show that the user has subscribed, without actually grbabing an updated user object
                //     //   })
                //     //   .catch(error => {
                //     //     console.log(error)
                //     //   })
                //   })
                //   .catch(error => {
                //     console.log(error)
                //   })

                axios.post(`/stripe-collect-payment-from-existing-customer/`, {
                  // stripe_payer_account: 'cus_HAi1VQH6AqOcLU',
                  // stripe_payer_account: this.user.stripe_customer_id,
                  stripe_payer_account: res.data.stripe_customer.id,
                  // stripe_payee_account: 'acct_1GJgJzCnTKhNI2s2', // LocalStudent account ID through Enginehire Stripe connect
                  stripe_payee_account: stripeAccount,
                  // stripe_payee_account: this.jobFiller.stripe_connect_id,
                  // organization: 'LocalStudent',
                  // amount: Math.round(parseFloat(this.totalPrice).toFixed(2) * 100),
                  // amount: 100,
                  amount: 25000,
                  // fee: Math.round((parseFloat(this.totalPrice) - parseFloat(this.studentPay)).toFixed(2) * 100),
                  receipt_email: vm.user.email,
                  // receipt_email: 'enginehire@gmail.com',
                  currency: 'usd',
                })
                  .then(res => {
                    // console.log(res)
                  })
                  .catch(error => {
                    console.log(error)
                  })
              })
              .catch(error => {
                console.log(error)
              })
          }
        });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/Payments.vue